import type { EnhancedPage } from '../../types/navigation';

/**
 * Utility functions for page operations
 */

/**
 * Build a lookup map for fast page access by href
 */
export function buildPageLookupMap(pages: EnhancedPage[]): Record<string, EnhancedPage> {
  const map: Record<string, EnhancedPage> = {};
  pages.forEach((page) => {
    map[page.href] = page;
  });
  return map;
}

/**
 * Find page index by CFI comparison
 */
export function findPageIndexByCfi(
  pages: EnhancedPage[],
  targetCfi: string,
  compareFn: (a: string, b: string) => number,
): number {
  if (pages.length === 0) return -1;

  let matchedIndex = 0;

  for (let i = 0; i < pages.length; i++) {
    const pageCfi = pages[i].cfi;
    if (!pageCfi) continue;

    // If the target is AT or AFTER this page
    if (compareFn(targetCfi, pageCfi) >= 0) {
      matchedIndex = i;
    } else {
      // We've hit a page that is ahead of us, so we stop
      break;
    }
  }

  return matchedIndex;
}
